//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast} from 'vue-ydui/dist/lib.rem/dialog';
import {getList} from '@/api/credit_score';
import vueWaterfallEasy from 'vue-waterfall-easy'
export default {
  data() {
    return {
      list:[],
    };
  },
  components: {
    vueWaterfallEasy
  },
  methods: {
    getList(){
      //先验证是否有库存

      let params = {}
      getList(params).then((res) => {
        if(res.code == 200){
          this.list = JSON.parse(res.data);

        }
      })

    },
    toDetail(event, { index, value }){
      event.preventDefault()
      // 只有当点击到图片时才进行操作
      if (event.target.tagName.toLowerCase() == 'img') {
        console.log('img clicked',index, value)
        console.log(value.id)
        //window.location.href="http://www.baidu.com"
        window.location.href="yp://app?type=shopdetail&id="+value.id;
      }
    },
    to_card(){
      window.location.href="yp://app?type=card";
    },

    showToast(content,timeout,icon){
      this.$dialog.toast({
        mes: content,
        timeout: timeout,
        icon: icon,
      });
    },


  },
  mounted () {

    this.getList();
  }
};



// WEBPACK FOOTER //
// ./src/pages/credit_score/product_list.vue